import { apiClient } from '~/api/client';
import type { components } from '~/types/api';

export type AuthUser = components['schemas']['User'];
export type Company = components['schemas']['Company'];
export type LoginRequest = components['schemas']['LoginRequest'];
export type LoginResponse = components['schemas']['LoginResponse'];
export type MeResponse = components['schemas']['MeResponse'];

/** `officeSlug` é o do escritório dono do endereço (`TenantGate`): a sessão nasce nele. */
export async function login(
  email: string,
  password: string,
  officeSlug: string,
): Promise<LoginResponse> {
  const credentials: LoginRequest = { email, password, office_slug: officeSlug };
  const response = await apiClient.post<LoginResponse>('/auth/api/auth/login/', credentials);
  return response.data;
}

export async function fetchMe(): Promise<MeResponse> {
  const response = await apiClient.get<MeResponse>('/auth/api/auth/me/');
  return response.data;
}

export async function logoutApi(refreshToken: string): Promise<void> {
  await apiClient.post('/auth/api/auth/logout/', { refresh: refreshToken });
}
